import type { Dictionnaire } from '../type';

export const messages: Dictionnaire['messages'] = {
  amis: {
    croise: 'Coincidisteis en un evento',
    soiMeme: 'No puedes añadirte a ti mismo',
    compteOfficiel: 'La cuenta de la aplicación no se puede añadir como amigo. Puedes escribirle.',
    bloque: 'Has bloqueado a este miembro: desbloquéalo antes de enviarle una solicitud de amistad',
    refuse: 'Este miembro no acepta tu solicitud por ahora',
    plusDeDemande: 'Esta solicitud ya no existe',
    nouveau: 'Nuevo en el spot',
  },
  erreurs: {
    plusDeConversation: 'Esta conversación ya no existe',
    pasMembre: 'No formas parte de esta conversación',
    demandeEnAttente: 'Tu mensaje se ha enviado. Podrás seguir cuando esta persona te responda.',
    plusAmis: 'Ya no sois amigos: esta conversación está cerrada',
    injoignable: 'Este miembro no recibe tus mensajes por ahora',
    vide: 'Escribe un mensaje antes de enviarlo',
    effacerLesSiens: 'Solo puedes borrar tus propios mensajes',
    modifierLesSiens: 'Solo puedes editar tus propios mensajes',
    tropTardPourModifier: 'Un mensaje solo se puede editar en los 15 minutos siguientes a su envío.',
    priveSansNom: 'Una conversación privada no tiene nombre',
    renommerAdmin: 'Solo el administrador puede cambiar el nombre del grupo',
    nomDuGroupe: 'Ponle un nombre al grupo',
    priveSansDescription: 'Una conversación privada no tiene descripción',
    descriptionAdmin: 'Solo el administrador puede cambiar la descripción',
    priveSansAdmin: 'Una conversación privada no tiene administrador',
    passerAdmin: 'Solo el administrador del grupo puede traspasarlo',
    plusDansLeGroupe: 'Este miembro ya no está en el grupo',
    priveSansMembres: 'Una conversación privada no tiene miembros',
    retirerAdmin: 'Solo el administrador del grupo puede quitar a un miembro',
    utiliseQuitter: 'Usa «Salir del grupo»',
    priveSansPhoto: 'Una conversación privada no tiene foto',
    photoAdmin: 'Solo el administrador del grupo puede cambiar su foto',
    soiMeme: 'No puedes hablar contigo mismo',
    bloque: 'Has bloqueado a este miembro. Desbloquéalo desde su perfil para escribirle.',
    priveFermee: 'Una conversación privada no admite más miembros',
    groupeDeSortie: 'A este grupo se entra uniéndose a la salida, no por invitación',
    groupeDAsso: 'A este grupo se entra uniéndose a la asociación, no por invitación',
    amisSeulement: 'Solo puedes añadir a tus amigos a un grupo',
    priveNeSeQuittePas: 'De una conversación privada no se puede salir',
    successeur: 'Elige quién se queda con el grupo antes de irte.',
  },
  apercu: {
    groupe: 'Grupo',
    photo: 'Foto',
    vocal: 'Mensaje de voz',
    video: 'Vídeo',
    sortie: 'Evento compartido',
    post: 'Publicación compartida',
    nouveau: 'Nuevo mensaje',
  },
  commun: {
    photo: 'Foto',
    vocal: 'Mensaje de voz',
    video: 'Vídeo',
    sortie: 'Evento compartido',
    post: 'Publicación compartida',
    message: 'Mensaje',
    supprime: 'Mensaje borrado',
    ecrit: 'escribiendo...',
    nouveauMessage: 'Nuevo mensaje',
    quitterGroupe: 'Salir del grupo',
    aucunMembre: 'No se ha encontrado ningún miembro',
    verifie: 'Revisa cómo se escribe el nombre de usuario.',
    aucunAmi: 'Todavía no tienes amigos',
    chercheUnPseudo: 'Busca un nombre de usuario para invitar a alguien que todavía no es tu amigo.',
    rechercherPseudo: 'Buscar un nombre de usuario...',
    infosGroupe: 'Información del grupo',
    membres: 'Miembros',
    toi: 'Tú',
    moi: 'Yo',
    retirerQuelquun: (nom: string) => `Quitar a ${nom}`,
    laisserEtPartirQ: (nom: string) => `¿Dejar el grupo a ${nom} y salir?`,
  },
  conversation: {
    pasParti: 'No se ha podido enviar este mensaje.',
    pasModifie: 'No se ha podido editar este mensaje.',
    microIndisponible: 'Micrófono no disponible',
    vocalImpossible: 'No se ha podido enviar el mensaje de voz',
    envoiImpossible: 'No se puede enviar ahora mismo.',
    copie: 'Mensaje copiado.',
    plusCharge: 'Este mensaje ya no está en la parte cargada de la conversación.',
    reactionEchec: 'La reacción no se ha enviado. Vuelve a intentarlo.',
    effacement: 'Los mensajes se borran una semana después de leerse.',
    pasAmis: 'No sois amigos: solo puedes enviar un mensaje. La conversación se abrirá si esta persona te responde.',
    dernierMessage: 'Ir al último mensaje',
    plusAmis: 'Ya no sois amigos: esta conversación está cerrada. Vuelve a enviarle una solicitud de amistad desde su perfil para retomar la conversación.',
    voirCite: 'Ver el mensaje citado',
    annulerReponse: 'Dejar de responder a este mensaje',
    annulerModif: 'Dejar de editar este mensaje',
    modifierLeMessage: 'Editar el mensaje',
    ecrire: 'Escribe un mensaje...',
    annulerEnregistrement: 'Cancelar la grabación',
    reprendre: 'Reanudar la grabación',
    galerie: 'Elegir de la galería',
    enregistrerVocal: 'Grabar un mensaje de voz',
    lacherAnnuler: 'Suelta para cancelar',
    lacherEnvoyer: 'Suelta para enviar',
    envoyerVocal: 'Enviar el mensaje de voz',
    envoyer: 'Enviar',
    actions: 'Acciones del mensaje',
    autreEmoji: 'Elegir otro emoji',
    repondre: 'Responder',
    copier: 'Copiar el texto',
    modifier: 'Editar',
    infos: 'Información',
    supprimerQ: '¿Borrar este mensaje?',
    supprimer: 'Borrar',
    chercherEmoji: 'Buscar un emoji',
    reactions: 'Reacciones',
    retraitEchec: 'No se ha podido quitar. Vuelve a intentarlo.',
    appuyerSupprimer: 'Pulsa para quitarla.',
    infosMessage: 'Información del mensaje',
    vu: 'Visto',
    pasEncore: 'todavía no',
    distribue: 'Entregado',
    ceMembre: 'este miembro',
    photoEnvoyee: 'Foto enviada en la conversación',
    voirReactions: 'Ver quién ha reaccionado',
    postIndisponible: 'Esta publicación ya no está disponible.',
    voirProfil: (nom: string) => `Ver el perfil de ${nom}`,
    plusieursEcrivent: (n: number) => `${n} personas están escribiendo...`,
    appelerVideo: (nom: string) => `Videollamada a ${nom}`,
    appeler: (nom: string) => `Llamar a ${nom}`,
    nouveaux: (n: number) => `${n} mensaje${n === 1 ? '' : 's'} nuevo${n === 1 ? '' : 's'}`,
    retirerReaction: (emoji: string) => `Quitar ${emoji}`,
    reagirAvec: (emoji: string) => `Reaccionar con ${emoji}`,
    aucunEmoji: (quete: string) => `Ningún emoji para «${quete}».`,
    systeme: {
      retire: (nom: string) => `${nom} ha sido eliminado del grupo.`,
      rejoint: (nom: string) => `${nom} se ha unido al grupo.`,
      quitte: (nom: string) => `${nom} ha salido del grupo.`,
      tuAsQuitte: 'Has salido del grupo.',
      plusAmi: (nom: string) =>
        `Ya no eres amigo de ${nom}. La conversación se reanudará cuando volváis a ser amigos.`,
    },
    appel: {
      manque: (video: boolean) => `${video ? 'Videollamada' : 'Llamada'} perdida`,
      duree: (video: boolean, duree: string) => `${video ? 'Videollamada' : 'Llamada'} · ${duree}`,
    },
    lu: 'Leído',
    modifie: 'Editado',
  },
  ajouterAmis: {
    titre: 'Añadir amigos',
    boutons: {
      none: 'Añadir',
      requested: 'Solicitado',
      incoming: 'Aceptar',
      friends: 'Amigos',
    },
    demandesRecues: (n: number) => `Solicitudes recibidas · ${n}`,
    suggestions: (lieu: string | null) => `Sugerencias${lieu ? ` en ${lieu}` : ''}`,
    tousLesMembres: (n: number) => `Todos los miembros · ${n}`,
    accepter: (nom: string) => `Aceptar a ${nom}`,
    refuser: (nom: string) => `Rechazar a ${nom}`,
  },
  ajouterMembres: {
    impossible: 'No se puede añadir ahora mismo.',
    titre: 'Añadir miembros',
    choisis: 'Elige a quién añadir',
    resultats: 'Resultados',
    tesAmis: 'Tus amigos',
    dejaMembre: 'Ya es miembro',
    ajouter: (n: number) => `Añadir ${n} miembro${n === 1 ? '' : 's'}`,
  },
  groupe: {
    descriptionImpossible: 'No se ha podido guardar la descripción',
    renommageImpossible: 'No se ha podido cambiar el nombre',
    passerImpossible: 'No se ha podido traspasar',
    retirerImpossible: 'No se ha podido quitar a este miembro',
    photoImpossible: 'No se ha podido guardar la foto',
    quitterImpossible: 'No se ha podido salir del grupo',
    quitterQ: '¿Salir del grupo?',
    nommerAdmin: 'Nombrar administrador',
    retirer: 'Quitar del grupo',
    changerPhoto: 'Cambiar la foto del grupo',
    voirPhoto: 'Ver la foto del grupo a pantalla completa',
    modifierNom: 'Cambiar el nombre del grupo',
    ajouterMembre: 'Añadir un miembro',
    modifierDescription: 'Cambiar la descripción del grupo',
    ajouterDescription: 'Añadir una descripción',
    deQuoi: '¿De qué va este grupo?',
    admin: 'Admin',
    retirerQ: (nom: string) => `¿Quitar a ${nom} del grupo?`,
    meta: (n: number, date: string) => `${n} miembro${n === 1 ? '' : 's'} · creado el ${date}`,
  },
  passation: {
    orphelin: '¿A quién le confías el grupo?',
    laisser: '¿A quién le dejas el grupo?',
  },
  demandes: {
    titre: 'Solicitudes de mensaje',
    aucune: 'Ninguna solicitud',
    aucuneAide: 'Los primeros mensajes de miembros que todavía no conoces llegarán aquí.',
  },
  liste: {
    supprimerQ: '¿Borrar esta conversación?',
    nouveauGroupe: 'Nuevo grupo',
    demandesMessage: 'Solicitudes de mensaje',
    ajouterAmis: 'Añadir amigos',
    reactiverSon: 'Reactivar el sonido',
    sourdine: 'Silenciar',
    signaler: 'Denunciar la conversación',
    supprimer: 'Borrar la conversación',
    vide: 'Todavía no hay mensajes',
    videAide: 'Escribe a alguien desde su perfil, o únete a una salida para conocer gente.',
    rechercher: 'Buscar una conversación...',
    discussions: 'Conversaciones',
    messages: 'Mensajes',
    comptes: 'Cuentas',
    envoyerUnMessage: 'Enviar un mensaje',
    toiDeuxPoints: 'Tú: ',
    enSourdine: 'Silenciada',
    plusAmis: 'Ya no sois amigos',
    appelManque: 'Llamada perdida',
    appel: 'Llamada',
    premier: '¡Envía un primer mensaje!',
    quitterQ: (nom: string) => `¿Salir de ${nom}?`,
    demandesMessageEnAttente: (n: number) => `Solicitudes de mensaje · ${n} pendientes`,
    demandesAmiEnAttente: (n: number) => `Solicitudes de amistad · ${n} pendientes`,
    laisserEtPartirQ: (groupe: string, nom: string) => `¿Dejar ${groupe} a ${nom} y salir?`,
    aucuneDiscussion: (recherche: string) => `Ninguna conversación coincide con «${recherche}».`,
    auteur: (nom: string) => `${nom}: `,
    nonLus: 'Mensajes nuevos',
    systeme: {
      quitte: (nom: string) => `${nom} ha salido del grupo`,
      retire: (nom: string) => `${nom} ha sido eliminado del grupo`,
      rejoint: (nom: string) => `${nom} se ha unido al grupo`,
    },
  },
  nouveauGroupe: {
    impossible: 'No se puede crear ahora mismo.',
    titre: 'Nuevo grupo',
    creer: 'Crear el grupo',
    choisirPhoto: 'Elegir una foto de grupo',
    nom: 'Nombre del grupo',
    nomExemple: 'Los pícnics',
    description: 'Descripción',
    descriptionExemple: 'Quedamos en el parque cuando hace bueno',
    chercher: 'Buscar cualquier nombre de usuario...',
    selectionnes: (n: number) => `${n} seleccionados`,
  },
  annuaire: {
    rechercher: 'Buscar un miembro',
    vide: 'Nadie más por ahora',
    videAide: 'Los miembros del servidor aparecerán aquí en cuanto tengan acceso.',
    aucun: (recherche: string) => `Ningún miembro coincide con «${recherche}»`,
    ecrireA: (nom: string) => `Escribir a ${nom}`,
    formation: {
      aide: 'Aparecerás en su bloque del directorio.',
      actuelle: 'Tu programa',
    },
    sansFormation: 'Programa sin indicar',
    voir: (nom: string) => `Ver los miembros: ${nom}`,
    videFormation: 'Nadie en este programa por ahora',
    accueil: {
      etudiants: 'Estudiantes',
      etudiantsAide: 'Todos los alumnos, por formación',
      associations: 'Asociaciones',
      associationsAide: 'Su muro, sus eventos y cómo unirse',
    },
    maFormation: {
      bouton: 'Mi formación',
      choisir: 'Indicar mi formación',
      aucune: 'No indicarla',
      enregistree: 'Formación guardada',
      impossible: 'No se pudo guardar tu formación. Inténtalo de nuevo.',
    },
    associations: {
      titre: 'Asociaciones',
      categories: { bde: 'Oficinas de estudiantes', citoyennes: 'Cívicas', creatives: 'Creativas', culturelles: 'Culturales', humanitaires: 'Humanitarias', conviviales: 'De convivencia', internationales: 'Internacionales', professionnelles: 'Profesionales', sportives: 'Deportivas y clubes' },
      vide: 'Todavía no hay asociaciones',
      rechercher: 'Buscar una asociación',
      aucune: (recherche: string) => `Ninguna asociación coincide con «${recherche}»`,
      membres: (n: number) => `${n} miembro${n > 1 ? 's' : ''}`,
      chef: 'Responsable',
      membre: 'Miembro',
      enAttente: 'Solicitud enviada',
      rejoindre: 'Pedir unirme',
      annulerDemande: 'Cancelar mi solicitud',
      quitter: 'Dejar la asociación',
      quitterQ: (nom: string) => `¿Dejar ${nom}?`,
      demandeEnvoyee: 'Solicitud enviada al responsable',
      fil: 'Muro',
      evenements: 'Eventos',
      lesMembres: 'Miembros',
      ecrire: 'Publicar en el muro',
      creerEvenement: 'Crear un evento',
      filVide: 'Todavía no hay nada en el muro',
      evenementsVide: 'No hay eventos próximos',
      demandes: (n: number) => `Solicitudes para unirse (${n})`,
      accepter: (nom: string) => `Aceptar a ${nom}`,
      refuser: (nom: string) => `Rechazar a ${nom}`,
      retirer: (nom: string) => `Quitar a ${nom} de la asociación`,
      retirerQ: (nom: string) => `¿Quitar a ${nom} de la asociación?`,
      sansChef: 'Esta asociación aún no tiene responsable para aceptar solicitudes.',
      reserveMembres: 'Todos leen su muro y sus eventos; solo sus miembros publican.',
      groupe: 'Grupo de la asociación',
      groupePasPret: 'El grupo se está preparando, vuelve a intentarlo en un momento.',
      introuvable: 'Asociación no encontrada',
      impossible: 'No se pudo completar. Inténtalo de nuevo.',
      dansLeFil: (nom: string) => `En el muro de ${nom}`,
      pourLAsso: (nom: string) => `Evento de ${nom}`,
      voir: (nom: string) => `Ver la asociación ${nom}`,
    },
    filtres: {
      titre: 'Filtros',
      filtrer: 'Filtrar miembros',
      actifs: 'Filtros activos',
      formation: 'Programa',
      langues: 'Idiomas',
      effacer: 'Borrar todo',
      fermer: 'Ver los miembros',
      aucun: 'Ningún miembro coincide con estos filtros',
    },
  },
};
